import React, { useState } from "react";
import { BuyerRejectionsReport } from "@/components/analytics/BuyerRejectionsReport";
import { PausedTrafficList } from "@/components/analytics/PausedTrafficList";

const TABS = [["rates", "Rejection rates"], ["paused", "Paused traffic"]];

export default function BuyerRejections() {
  const [tab, setTab] = useState("rates");
  return (
    <div data-testid="buyer-rejections-page">
      <div className="mb-6">
        <div className="label-mono">Analytics</div>
        <h1 className="font-chivo text-4xl font-black uppercase leading-none tracking-tighter md:text-5xl">Buyer rejections</h1>
        <div className="mt-1 text-sm text-zinc-600">Which affiliates and funnels send leads your buyers turn down, so you can spot bad traffic early.</div>
      </div>
      <div className="mb-4 flex gap-1" data-testid="buyer-rejections-tabs">
        {TABS.map(([k, label]) => (
          <button key={k} type="button" onClick={() => setTab(k)} data-testid={`buyer-rejections-tab-${k}`}
                  className={`border-2 border-black px-3 py-1.5 text-xs uppercase tracking-widest transition-colors duration-100 ${tab === k ? "bg-black text-white" : "bg-white hover:bg-zinc-100"}`}>
            {label}
          </button>
        ))}
      </div>
      {tab === "rates" ? <BuyerRejectionsReport /> : <PausedTrafficList />}
    </div>
  );
}
